import _ from 'lodash'
import { Vue, Component, Prop, } from 'vue-property-decorator'

@Component({
    name: 'LeftRight',
})
export class LeftRightImpl extends Vue {
    @Prop({
        type: String,
    }) leftTooltip: string

    @Prop({
        type: String
    }) rightTooltip: string

    @Prop({
        type: Boolean,
        default: false,
    }) disabledLeft: boolean

    @Prop({
        type: Boolean,
        default: false,
    }) disabledRight: boolean

    get HasLeftTooltip() {
        return !this.disabledLeft && this.leftTooltip
    }

    get HasRightTooltip() {
        return !this.disabledRight && this.rightTooltip
    }


    //#region Left
    onClickLeft() {
        if (this.disabledLeft) { return }
        this.$emit('clickleft')
    }
    //#endregion

    //#region Right
    onClickRight() {
        if (this.disabledRight) { return }
        this.$emit('clickright')
    }
    //#endregion
}
